"use client";

import { Heading, Text } from "@pamperedchef/design-system";
import * as styles from "./SectionHeading.module.scss";

export interface SectionHeadingProps {
	eyebrow?: string;
	headline?: string;
	subcopy?: string;
	alignment?: "left" | "center";
}

/**
 * Shared section header — eyebrow + headline + subcopy. The headline renders
 * in the brand teal serif (Questa) and is left-aligned by default to match the
 * VIP-kit section rhythm ("Your Exclusive Offer", "Explore other kits").
 * Presentational, props-in.
 */
export function SectionHeading({
	eyebrow,
	headline,
	subcopy,
	alignment = "left"
}: SectionHeadingProps) {
	if (!eyebrow && !headline && !subcopy) return null;

	return (
		<header
			className={styles["section-heading"]}
			data-component="SectionHeading"
			data-alignment={alignment}
		>
			{eyebrow ? (
				<Text
					tag="p"
					styledAs="xsb"
					className={styles["section-heading__eyebrow"]}
				>
					{eyebrow}
				</Text>
			) : null}
			{headline ? (
				<Heading
					tag="h2"
					styledAs="h2"
					className={styles["section-heading__headline"]}
				>
					{headline}
				</Heading>
			) : null}
			{subcopy ? (
				<Text
					tag="p"
					styledAs="mdr"
					className={styles["section-heading__subcopy"]}
				>
					{subcopy}
				</Text>
			) : null}
		</header>
	);
}
